import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { canViewReports, isAdministrator } from "../../utils/access";

export function AdminOnlyRoute() {
  const { user } = useAuth();
  const location = useLocation();

  if (!isAdministrator(user)) {
    return <Navigate to="/sites" replace state={{ accessDenied: true, from: location.pathname }} />;
  }
  return <Outlet />;
}

export function ReportRoute() {
  const { user } = useAuth();
  const location = useLocation();

  if (!canViewReports(user)) {
    return <Navigate to="/sites" replace state={{ accessDenied: true, from: location.pathname }} />;
  }
  return <Outlet />;
}
